import _ from "lodash";

import streamApi from "@/api/streamApi";
import machineProductionComponentsTemplate from "@/api/json/machineProductionComponentsTemplate";

function getLastVal(pub) {
  let last_val = pub.data.v !== undefined ? pub.data.v.toString() : "";
  if (!isNaN(last_val.replace(",", ".").replace(" ", "")) && !!last_val) {
    last_val = Number(last_val.replace(",", ".").replace(" ", ""));
  }
  return last_val;
}

export default {
  state: {
    items: [],
    channels: [],
    speedOverrideEnabled: false,
    feedOverrideEnabled: false
  },
  getters: {
    getFullItems: state => state.items,
    getItems: state => {
      return state.items.filter(item => !!item.widget && !!item.widget.name);
    },
    getSpeedOverrideEnabled: state => state.speedOverrideEnabled,
    getFeedOverrideEnabled: state => state.feedOverrideEnabled
    /*getValueByKeyTopic: state => topic => {
      let value = state.values.find(value => value.key_topic === topic);
      return !!value ? value.data : null;
    }*/
  },
  actions: {
    subscribe: ({ commit, dispatch }, arg) => {
      if (machineProductionComponentsTemplate[arg.template]) {
        dispatch("subscribeMachineFamilyVariables", arg.template);
      }

      if (arg.enableSpeedOverride) {
        commit("ENABLE_SPEEDOVERRIDE");
      }
      if (arg.enableFeedOverride) {
        commit("ENABLE_FEEDOVERRIDE");
      }
    },

    // @param arg String: machineFamily
    subscribeMachineFamilyVariables: ({ dispatch }, args) => {
      const template = machineProductionComponentsTemplate[args];
      dispatch("subscribeVariables", template);
    },

    subscribeVariables: async ({ state, commit, rootGetters }, args) => {
      const idForStreamApi = rootGetters["Machine/getSelected"].Id;

      // Get all channel
      const allChannels = await streamApi.getChannels(
        rootGetters["Machine/getSelected"].Id,
        args.on
      );

      args.templates.forEach(async template => {
        // Get values to filter
        const fetchDataSelectors = await Promise.all(
          allChannels.map(
            channel =>
              streamApi.getQueryDataLast(idForStreamApi, channel + template.selectors.on) || {}
          )
        );

        // Filter by selectors.value
        const fetchSelectorsValue = _.without(fetchDataSelectors, null).filter(
          payload => payload.data.v === template.selectors.value
        );

        // Eval selectors found
        fetchSelectorsValue.forEach(async pubSelector => {
          const topicFound = pubSelector.channel.split(`/${template.selectors.on}`)[0];
          let newNode = {
            pid: args.ref,
            id: `${args.ref}_${topicFound}`,
            label: "", // `[${template.selectors.value}] `,
            hasChild: !!template.selectors.children && template.selectors.children.length > 0
          };

          // Eval attributes Label
          const newAttributesNode = async () => {
            if (template.selectors.attributes) {
              // Get values childrens to filter
              const getAttributes = await Promise.all(
                template.selectors.attributes.map(attr =>
                  streamApi.getQueryDataLast(idForStreamApi, `${topicFound}/${attr.on}`)
                )
              );

              newNode.label = `${getAttributes.map(attr => attr.data.v || "").join()} `; // "," default separator on concat labels

              return newNode;
            } else {
              return newNode;
            }
          };

          newNode = await newAttributesNode();

          state.items.push(newNode);

          // Eval childrens
          if (newNode.hasChild) {
            template.selectors.children.forEach(async currentChildren => {
              // Get all children channel
              const childrenChannels = await streamApi.getChannels(
                rootGetters["Machine/getSelected"].Id,
                `${topicFound}/${args.children.on}`
              );

              // Get values childrens to filter
              const fetchDataCurrentChildrens = await Promise.all(
                childrenChannels.map(channel =>
                  streamApi.getQueryDataLast(idForStreamApi, `${channel}${currentChildren.on}`)
                )
              );

              // Filter Childrens Data by children.value
              const fetchCurrentChildrenValue = _.without(fetchDataCurrentChildrens, null).filter(
                payload => payload.data.v === currentChildren.value
              );

              // Eval children found
              fetchCurrentChildrenValue.forEach(async pubChildren => {
                const subTopicFound = pubChildren.channel.split(`/${currentChildren.on}`)[0];
                let newSub = {
                  pid: `${args.ref}_${topicFound}`,
                  id: `${args.ref}_${subTopicFound}`,
                  label: "", //`${newNode.label} [${currentChildren.value}] `,
                  hasChild: false
                };

                // Eval attributes Label
                const newSubGetattributes = async () => {
                  if (currentChildren.attributes) {
                    // Get values childrens to filter
                    const getAttributes = await Promise.all(
                      currentChildren.attributes.map(attr =>
                        streamApi.getQueryDataLast(idForStreamApi, `${subTopicFound}/${attr.on}`)
                      )
                    );
                    newSub.label = `${newNode.label}${getAttributes
                      .map(attr => attr.data.v || "")
                      .join()} `; // "," default separator on concat labels

                    return newSub;
                  } else {
                    return newSub;
                  }
                };

                newSub = await newSubGetattributes();
                state.items.push(newSub);

                // Get VARIABLES
                for (const key_variable in template.variables) {
                  streamApi.subLatest(
                    idForStreamApi,
                    `${subTopicFound}/${template.variables[key_variable].on}`,
                    function (pub) {
                      if (_.findIndex(state.channels, pub.channel) < 0) {
                        state.channels.push(pub.channel);
                      }

                      const widget_name = template.variables[key_variable].widget;
                      const newVar = {
                        pid: `${args.ref}_${subTopicFound}`,
                        id: `${args.ref}_${pub.channel}`,
                        label: `${newSub.label} › ${key_variable}`,
                        data: [
                          {
                            v: getLastVal(pub),
                            ts: pub.data.ts
                          }
                        ],
                        widget: {
                          name: widget_name,
                          options: template.widgets[widget_name][key_variable].options
                        }
                      };

                      commit("UPDATE_VARIABLE", newVar);
                    }
                  );
                }
              });
            });
          }
        });
      });
    },

    unsubscribe: ({ state, commit, rootGetters, dispatch }) => {
      const m = rootGetters["Machine/getSelected"];
      if (m && m.Device) {
        if (state.channels.length > 0) {
          const deviceID = rootGetters["Machine/getSelected"].Device.Device_Id;
          dispatch("unsubscribeMachineFamilyVariables", deviceID);
        }
        commit("RESET");
      }
    },

    unsubscribeMachineFamilyVariables: ({ state, commit, rootGetters }) => {
      const idForStreamApi = rootGetters["Machine/getSelected"].Id;
      state.channels.forEach(ch => {
        streamApi.unsub(idForStreamApi, ch, function () {});
      });

      commit("RESET_ITEMS");
    }
  },
  mutations: {
    ENABLE_SPEEDOVERRIDE: state => {
      state.speedOverrideEnabled = true;
    },
    ENABLE_FEEDOVERRIDE: state => {
      state.feedOverrideEnabled = true;
    },
    UPDATE_VARIABLE: (state, payload) => {
      const idx = state.items.findIndex(item => item.id === payload.id);
      if (idx > -1) {
        Object.assign(state.items[idx], payload);
      } else {
        state.items.push(payload);
      }
    },
    RESET_ITEMS: state => {
      state.channels = [];
      state.items = [];
    },
    RESET: state => {
      state.feedOverrideEnabled = false;
      state.speedOverrideEnabled = false;
    }
  },
  namespaced: true
};
